import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import DescriptionIcon from '@mui/icons-material/Description';

import IconButton from '../../common/buttons/IconButton';

import { API_URL } from '../../../services/settings';

const DownloadUBLButton = () => {
    const record = useRecordContext();
    const translate = useTranslate();

    return (
        <IconButton
            icon={<DescriptionIcon />}
            component="a"
            target="__blank"
            href={`${API_URL}/invoices/${record?.id}/ubl.xml`}
        >
            UBL
        </IconButton>
    );
};

export default DownloadUBLButton;
